import { Component, OnInit } from '@angular/core';
import { IBranch } from 'app/shared/Domains/branch';
import { ActivatedRoute } from '@angular/router';
import { Configuration } from 'config/config';
import { AppServiceManager } from 'common/services/appServiceManager';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
    selector: 'app-login-logs',
    templateUrl: './login-logs.component.html',
    styleUrls: ['./login-logs.component.css']
})
export class LoginLogsComponent implements OnInit {
    [x: string]: any;
    active: boolean = true;
    previewUrl: string;
    selectedFile: File;
    branches: IBranch;
    member: any;
    isEmailLoader: boolean = false;
    loading: boolean = false;
    isSuccess: boolean;
    isError: boolean;
    totalCount: any;
    selectedBranch: any;
    branch: string;
    company: string;
    balance: number;
    messageService: any;
    loginLogs: any[] = [];
    loginLogsdata: any = [];

    constructor(
        private LanguageService: LanguageService,
        private route: ActivatedRoute,
        public config: Configuration,
        private appServiceManager: AppServiceManager,


    ) { }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("LoginLogsComponent", label);
    }
    ngOnInit(): void {
        this.getLoginLogs();
    }

    getLoginLogs() {
        let endpoint = `login-logs`;
        this.appServiceManager.get(endpoint).subscribe(
            (res: any) => {
                const rows = Array.isArray(res?.data) ? res.data : [];
                this.totalCount = rows.length;
                let counter = 0;
                this.loginLogsdata = rows.map(item => ({
                    createdDate: new Date(item?.createdDate).toLocaleString(),
                    name: item?.name,
                    email: item.email? item.email : 'N/A',
                    contact: item?.contact,
                    city: item.city?item.city : 'N/A',
                    country: item.country?item.country : 'N/A',
                    username: item.username?item.username : 'N/A',
                    gymName: item.gymName?item.gymName : 'N/A',
                    ipAddress: item?.ipAddress,
                    ipLocation: Array.isArray(item?.ipLocation) ? item.ipLocation : [],
                    counter: counter = counter + 1
                }));
            },
            (error: any) => {
                this.loginLogsdata = [];
                this.totalCount = 0;
                this.messageService?.clear();
                this.messageService?.add({ severity: 'error', summary: 'Error Message', detail: error });
            }
        );
    }
}
